import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { testimonials } from '@/mocks/articles';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formMsg, setFormMsg] = useState('');

  const handleTipSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('phone_alt') as string || '').trim();

    if (honeypotVal) {
      setFormStatus('success');
      setFormMsg('投稿已提交，感谢您的爆料！我们会尽快审核 🍉');
      form.reset();
      return;
    }

    try {
      const data = new URLSearchParams();
      for (const [key, value] of formData.entries()) {
        if (key !== 'phone_alt') {
          data.append(key, value as string);
        }
      }

      const response = await fetch('https://readdy.ai/api/form/d96b8pfpg5pqhofcun20', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMsg('投稿已提交，感谢您的爆料！我们会尽快审核 🍉');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '提交失败，请稍后重试';
        setFormStatus('error');
        setFormMsg(serverMsg);
      }
    } catch {
      setFormStatus('error');
      setFormMsg('网络错误，请稍后重试');
    }
  };
  return (
    <>
      <Navbar />

      <main>
        {/* Hero */}
        <section className="relative w-full min-h-[420px] md:min-h-[500px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20elegant%20ink%20wash%20brushstrokes%20in%20circular%20motion%2C%20dark%20olive%20green%20and%20charcoal%20atmosphere%2C%20Chinese%20contemporary%20art%20style%2C%20sophisticated%20minimal%20composition%2C%20journalism%20and%20truth%20seeking%20theme%2C%20clean%20aesthetic%2C%20editorial%20quality&width=1600&height=900&seq=about-hero&orientation=landscape"
              alt="关于五一吃瓜网"
              title="关于五一吃瓜网"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <div className="mb-6">
              <nav className="inline-flex items-center gap-2 text-background-50/80 text-xs md:text-sm" aria-label="面包屑导航">
                <Link to="/" className="hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
                <span className="text-background-50/50">/</span>
                <span className="text-background-50">关于我们</span>
              </nav>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 mb-4">
              关于我们
            </h1>
            <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto mb-8">
              专业的网红黑料与网络热门事件爆料平台，致力于为吃瓜群众提供最真实、最及时的热点信息
            </p>

            <div className="flex items-center justify-center gap-4 flex-wrap">
              <a href="#contact" className="px-6 py-2.5 text-sm font-medium bg-foreground-900 text-background-50 rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer">
                联系合作
              </a>
              <Link
                to="/"
                className="px-6 py-2.5 text-sm font-medium border border-background-50/60 text-background-50 rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
              >
                品牌标识
              </Link>
            </div>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="w-full bg-background-50 py-16 md:py-20">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
            <div className="mb-4">
              <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">
                品牌理念
              </span>
            </div>

            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-900 leading-tight mb-8">
              让每一个吃瓜群众<br />
              都能第一时间<span className="text-accent-500">吃到真瓜</span>
            </h2>

            <div className="flex items-center gap-4 mb-8 flex-wrap">
              <Link
                to="/"
                className="px-6 py-2.5 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                商务合作
              </Link>
              <Link
                to="/"
                className="px-6 py-2.5 text-sm font-medium border border-foreground-300 text-foreground-700 rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                爆料投稿
              </Link>
            </div>

            <div className="space-y-4 text-sm md:text-base leading-relaxed text-foreground-700">
              <p>
                五一吃瓜网成立于2024年，是一家专注于网红黑料、娱乐圈八卦和网络热门事件的资讯平台。我们始终坚持"真实、及时、深度"的内容原则，为广大网民提供高质量的吃瓜内容。
              </p>
              <p>
                我们的编辑团队由资深媒体人和互联网从业者组成，拥有多年的娱乐新闻和网络热点追踪经验。我们建立了严格的信息核实机制，确保每一条爆料都经过多方交叉验证。
              </p>
              <p>
                截至目前，五一吃瓜网已累计发布超过5,000条原创爆料内容，月活跃用户超过800万，在全网拥有超过1,200万粉丝。我们与行业内多位资深爆料人保持着紧密的合作关系，能够在热点事件发生后第一时间获取独家消息。
              </p>
              <p>
                在未来，我们将继续扩大内容覆盖面，增加更多垂直领域的爆料追踪，同时优化用户体验，让每一位吃瓜群众都能更方便地获取最新、最全的吃瓜内容。
              </p>
            </div>
          </div>
        </section>

        {/* Honors & Features */}
        <section className="w-full bg-background-100 py-16 md:py-20">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                <span className="text-accent-500">专业</span> 可信
              </h2>
              <p className="text-sm text-foreground-500">我们坚持的标准与荣誉</p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
              <div className="lg:row-span-2 rounded-lg overflow-hidden h-[360px] lg:h-auto">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20team%20silhouettes%20working%20together%2C%20warm%20lighting%2C%20collaborative%20atmosphere%2C%20dark%20olive%20and%20amber%20tones%2C%20minimal%20composition%2C%20contemporary%20professional%20style%2C%20clean%20background&width=800&height=1000&seq=about-team&orientation=portrait"
                  alt="五一吃瓜网编辑团队"
                  title="五一吃瓜网专业编辑团队"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="bg-background-50 rounded-lg p-6 flex flex-col justify-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                  <i className="ri-time-line text-accent-600 text-lg"></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
                  每日更新承诺
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们承诺每日更新爆料内容，重大热点事件30分钟内上线，确保你不错过任何一个瓜。
                </p>
                <div className="mt-4 flex items-center gap-2">
                  <span className="text-2xl font-bold text-accent-500">5000+</span>
                  <span className="text-xs text-foreground-400">累计爆料</span>
                </div>
              </div>

              <div className="bg-background-50 rounded-lg p-6 flex flex-col justify-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 mb-4">
                  <i className="ri-radar-line text-secondary-600 text-lg"></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
                  全网追踪能力
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们覆盖全网主流平台，建立多渠道信息网络，确保爆料内容的广度和深度。
                </p>
                <div className="mt-4 flex items-center gap-2">
                  <span className="text-2xl font-bold text-secondary-500">1200万+</span>
                  <span className="text-xs text-foreground-400">全网粉丝</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="w-full bg-background-50 py-16 md:py-20">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                <span className="text-accent-500">联系</span> 我们
              </h2>
              <p className="text-sm text-foreground-500">商务合作、爆料投稿、意见反馈，欢迎联系我们</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto rounded-full bg-accent-100 mb-4">
                  <i className="ri-mail-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">商务合作</h3>
                <p className="text-xs text-foreground-500 mb-3">品牌推广、广告投放等合作</p>
                <a href="mailto:business@wuyichigua.com" className="text-sm text-primary-500 hover:text-primary-600 transition-colors">
                  business@wuyichigua.com
                </a>
              </div>

              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto rounded-full bg-secondary-100 mb-4">
                  <i className="ri-send-plane-line text-secondary-600 text-xl"></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">爆料投稿</h3>
                <p className="text-xs text-foreground-500 mb-3">提供一手爆料信息</p>
                <a href="mailto:tips@wuyichigua.com" className="text-sm text-primary-500 hover:text-primary-600 transition-colors">
                  tips@wuyichigua.com
                </a>
              </div>

              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto rounded-full bg-primary-100 mb-4">
                  <i className="ri-customer-service-line text-primary-600 text-xl"></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">客服咨询</h3>
                <p className="text-xs text-foreground-500 mb-3">问题反馈与帮助</p>
                <a href="mailto:support@wuyichigua.com" className="text-sm text-primary-500 hover:text-primary-600 transition-colors">
                  support@wuyichigua.com
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Tip Submission Form */}
        <section className="w-full bg-background-100 py-16 md:py-20">
          <div className="w-full max-w-2xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                <span className="text-accent-500">爆料</span> 投稿
              </h2>
              <p className="text-sm text-foreground-500">欢迎提供一手爆料信息，我们承诺严格保护爆料人隐私</p>
            </div>

            <form
              onSubmit={handleTipSubmit}
              className="bg-background-50 rounded-lg p-6 md:p-8 space-y-5"
              data-readdy-form=""
            >
              <div>
                <label htmlFor="tip_title" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  爆料标题 <span className="text-secondary-500">*</span>
                </label>
                <input
                  type="text"
                  id="tip_title"
                  name="tip_title"
                  required
                  placeholder="简要描述你的爆料内容"
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
              </div>

              <div>
                <label htmlFor="tip_content" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  详细内容 <span className="text-secondary-500">*</span>
                </label>
                <textarea
                  id="tip_content"
                  name="tip_content"
                  required
                  rows={5}
                  maxLength={500}
                  placeholder="请详细描述事件经过，包括时间、地点、人物、证据等（最多500字）"
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                />
                <p className="text-xs text-foreground-400 mt-1">最多500字</p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="tip_contact" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    联系方式（选填）
                  </label>
                  <input
                    type="text"
                    id="tip_contact"
                    name="tip_contact"
                    placeholder="邮箱或微信号"
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                </div>
                <div>
                  <label htmlFor="tip_category" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    爆料分类
                  </label>
                  <select
                    id="tip_category"
                    name="tip_category"
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200 rounded-lg text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors cursor-pointer"
                  >
                    <option value="">请选择分类</option>
                    <option value="wanghong">网红黑料</option>
                    <option value="yule">娱乐圈塌房</option>
                    <option value="redian">网络热点</option>
                    <option value="shehui">社会事件</option>
                    <option value="zhibo">直播翻车</option>
                  </select>
                </div>
              </div>

              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />

              <button
                type="submit"
                className="w-full py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                提交爆料
              </button>

              {formStatus !== 'idle' && (
                <p className={`text-sm text-center ${formStatus === 'success' ? 'text-primary-600' : 'text-secondary-500'}`}>
                  {formMsg}
                </p>
              )}
            </form>
          </div>
        </section>

        {/* Testimonials */}
        <section className="w-full bg-background-100 py-16 md:py-20">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                用户<span className="text-accent-500"> 评价</span>
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((t) => (
                <div key={t.id} className="bg-background-50 rounded-lg p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-400">{t.role}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {t.content}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="w-full bg-background-50 py-16 md:py-20">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                常见<span className="text-accent-500"> 问题</span>
              </h2>
            </div>

            <div className="space-y-3">
              {[
                { q: '五一吃瓜网是否可靠？', a: '我们坚持多方核实、交叉验证的原则，所有爆料内容均经过编辑团队的严格审核，标注信息来源，确保内容的真实性和可靠性。' },
                { q: '如何成为五一吃瓜网的爆料人？', a: '请发送邮件至 tips@wuyichigua.com，附上你的爆料信息和联系方式，我们的编辑会在24小时内与你取得联系。' },
                { q: '爆料人的隐私如何保护？', a: '我们严格保护爆料人的隐私信息，所有爆料均可做匿名处理，未经爆料人同意绝不透露任何个人信息。' },
                { q: '五一吃瓜网接受广告合作吗？', a: '是的，我们接受品牌合作与广告投放，请发送邮件至 business@wuyichigua.com 获取合作方案。' },
              ].map((faq, idx) => (
                <details key={idx} className="group bg-background-100 rounded-lg overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer">
                    <span className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                      {faq.q}
                    </span>
                    <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 ml-3">
                      <i className="ri-arrow-down-s-line text-foreground-500 group-open:hidden"></i>
                      <i className="ri-arrow-up-s-line text-foreground-500 hidden group-open:block"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* AboutPage Schema */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "关于五一吃瓜网",
          "description": "五一吃瓜网 - 专业的网红黑料与网络热门事件爆料平台",
          "url": "https://www.wuyichigua.com/about",
          "mainEntity": {
            "@type": "Organization",
            "name": "五一吃瓜网",
            "description": "专注于网红黑料、娱乐圈八卦和网络热门事件的资讯平台",
            "url": "https://www.wuyichigua.com",
            "foundingDate": "2024",
            "contactPoint": {
              "@type": "ContactPoint",
              "email": "business@wuyichigua.com",
              "contactType": "business cooperation"
            }
          },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://www.wuyichigua.com" },
              { "@type": "ListItem", "position": 2, "name": "关于我们", "item": "https://www.wuyichigua.com/about" }
            ]
          }
        })
      }} />

      {/* FAQPage Schema */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            { "@type": "Question", "name": "五一吃瓜网是否可靠？", "acceptedAnswer": { "@type": "Answer", "text": "我们坚持多方核实、交叉验证的原则，所有爆料内容均经过编辑团队的严格审核，标注信息来源，确保内容的真实性和可靠性。" } },
            { "@type": "Question", "name": "如何成为五一吃瓜网的爆料人？", "acceptedAnswer": { "@type": "Answer", "text": "请发送邮件至 tips@wuyichigua.com，附上你的爆料信息和联系方式，我们的编辑会在24小时内与你取得联系。" } },
            { "@type": "Question", "name": "爆料人的隐私如何保护？", "acceptedAnswer": { "@type": "Answer", "text": "我们严格保护爆料人的隐私信息，所有爆料均可做匿名处理，未经爆料人同意绝不透露任何个人信息。" } },
            { "@type": "Question", "name": "五一吃瓜网接受广告合作吗？", "acceptedAnswer": { "@type": "Answer", "text": "是的，我们接受品牌合作与广告投放，请发送邮件至 business@wuyichigua.com 获取合作方案。" } },
          ]
        })
      }} />
    </>
  );
}